import { render, staticRenderFns } from "./AllotDialog.vue?vue&type=template&id=4eca5e17&"
import script from "./AllotDialog.vue?vue&type=script&lang=js&"
export * from "./AllotDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports